import _slicedToArray from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["in", "unmountOnExit", "animateOpacity", "startingHeight", "endingHeight", "style", "className", "transition", "transitionEnd"],
    _excluded2 = ["unmountOnExit", "in", "className", "transition", "transitionEnd", "delay"],
    _excluded3 = ["unmountOnExit", "in", "reverse", "initialScale", "className", "transition", "transitionEnd", "delay"],
    _excluded4 = ["direction", "style", "unmountOnExit", "in", "className", "transition", "transitionEnd", "delay", "motionProps"],
    _excluded5 = ["unmountOnExit", "in", "reverse", "className", "offsetX", "offsetY", "transition", "transitionEnd", "delay"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// ../../../react-shim.js
import React from "react"; // ../../utilities/shared-utils/src/index.ts

var cx = function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  return classNames.filter(Boolean).join(" ");
};

function isDev() {
  return process.env.NODE_ENV !== "production";
}

var warn = function warn(options) {
  var condition = options.condition,
      message = options.message;

  if (condition && isDev()) {
    console.warn(message);
  }
}; // src/collapse.tsx


import { AnimatePresence, motion } from "framer-motion";
import { forwardRef, useEffect, useState } from "react"; // src/transition-utils.ts

var TRANSITION_EASINGS = {
  ease: [0.25, 0.1, 0.25, 1],
  easeIn: [0.4, 0, 1, 1],
  easeOut: [0, 0, 0.2, 1],
  easeInOut: [0.4, 0, 0.2, 1]
};
var TRANSITION_VARIANTS = {
  scale: {
    enter: {
      scale: 1
    },
    exit: {
      scale: 0.95
    }
  },
  fade: {
    enter: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  },
  pushLeft: {
    enter: {
      x: "100%"
    },
    exit: {
      x: "-30%"
    }
  },
  pushRight: {
    enter: {
      x: "-100%"
    },
    exit: {
      x: "30%"
    }
  },
  pushUp: {
    enter: {
      y: "100%"
    },
    exit: {
      y: "-30%"
    }
  },
  pushDown: {
    enter: {
      y: "-100%"
    },
    exit: {
      y: "30%"
    }
  },
  slideLeft: {
    position: {
      left: 0,
      top: 0,
      bottom: 0,
      width: "100%"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: "-100%",
      y: 0
    }
  },
  slideRight: {
    position: {
      right: 0,
      top: 0,
      bottom: 0,
      width: "100%"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: "100%",
      y: 0
    }
  },
  slideUp: {
    position: {
      top: 0,
      left: 0,
      right: 0,
      maxWidth: "100vw"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: 0,
      y: "-100%"
    }
  },
  slideDown: {
    position: {
      bottom: 0,
      left: 0,
      right: 0,
      maxWidth: "100vw"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: 0,
      y: "100%"
    }
  }
};

function getSlideTransition(options) {
  var _ref;

  var side = (_ref = options == null ? void 0 : options.direction) !== null && _ref !== void 0 ? _ref : "right";

  switch (side) {
    case "right":
      return TRANSITION_VARIANTS.slideRight;

    case "left":
      return TRANSITION_VARIANTS.slideLeft;

    case "bottom":
      return TRANSITION_VARIANTS.slideDown;

    case "top":
      return TRANSITION_VARIANTS.slideUp;

    default:
      return TRANSITION_VARIANTS.slideRight;
  }
}

var TRANSITION_DEFAULTS = {
  enter: {
    duration: 0.2,
    ease: TRANSITION_EASINGS.easeOut
  },
  exit: {
    duration: 0.1,
    ease: TRANSITION_EASINGS.easeIn
  }
};
var withDelay = {
  enter: function enter(transition, delay) {
    return _objectSpread(_objectSpread({}, transition), {}, {
      delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["enter"]
    });
  },
  exit: function exit(transition, delay) {
    return _objectSpread(_objectSpread({}, transition), {}, {
      delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["exit"]
    });
  }
}; // src/collapse.tsx

var isNumeric = function isNumeric(value) {
  return value != null && parseInt(value.toString(), 10) > 0;
};

var defaultTransitions = {
  exit: {
    height: {
      duration: 0.2,
      ease: TRANSITION_EASINGS.ease
    },
    opacity: {
      duration: 0.3,
      ease: TRANSITION_EASINGS.ease
    }
  },
  enter: {
    height: {
      duration: 0.3,
      ease: TRANSITION_EASINGS.ease
    },
    opacity: {
      duration: 0.4,
      ease: TRANSITION_EASINGS.ease
    }
  }
};
var variants = {
  exit: function exit(_ref2) {
    var _ref3;

    var animateOpacity = _ref2.animateOpacity,
        startingHeight = _ref2.startingHeight,
        transition = _ref2.transition,
        transitionEnd = _ref2.transitionEnd,
        delay = _ref2.delay;
    return _objectSpread(_objectSpread({}, animateOpacity && {
      opacity: isNumeric(startingHeight) ? 1 : 0
    }), {}, {
      height: startingHeight,
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit,
      transition: (_ref3 = transition == null ? void 0 : transition.exit) !== null && _ref3 !== void 0 ? _ref3 : withDelay.exit(defaultTransitions.exit, delay)
    });
  },
  enter: function enter(_ref4) {
    var _ref5;

    var animateOpacity = _ref4.animateOpacity,
        endingHeight = _ref4.endingHeight,
        transition = _ref4.transition,
        transitionEnd = _ref4.transitionEnd,
        delay = _ref4.delay;
    return _objectSpread(_objectSpread({}, animateOpacity && {
      opacity: 1
    }), {}, {
      height: endingHeight,
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter,
      transition: (_ref5 = transition == null ? void 0 : transition.enter) !== null && _ref5 !== void 0 ? _ref5 : withDelay.enter(defaultTransitions.enter, delay)
    });
  }
};
var Collapse = forwardRef(function (props, ref) {
  var isOpen = props.in,
      unmountOnExit = props.unmountOnExit,
      _props$animateOpacity = props.animateOpacity,
      animateOpacity = _props$animateOpacity === void 0 ? true : _props$animateOpacity,
      _props$startingHeight = props.startingHeight,
      startingHeight = _props$startingHeight === void 0 ? 0 : _props$startingHeight,
      _props$endingHeight = props.endingHeight,
      endingHeight = _props$endingHeight === void 0 ? "auto" : _props$endingHeight,
      style = props.style,
      className = props.className,
      transition = props.transition,
      transitionEnd = props.transitionEnd,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mounted = _useState2[0],
      setMounted = _useState2[1];

  useEffect(function () {
    var timeout = setTimeout(function () {
      setMounted(true);
    });
    return function () {
      return clearTimeout(timeout);
    };
  }, []);
  warn({
    condition: Boolean(startingHeight > 0 && unmountOnExit),
    message: "startingHeight and unmountOnExit are mutually exclusive. You can't use them together"
  });
  var hasStartingHeight = parseFloat(startingHeight.toString()) > 0;
  var custom = {
    startingHeight: startingHeight,
    endingHeight: endingHeight,
    animateOpacity: animateOpacity,
    transition: !mounted ? {
      enter: {
        duration: 0
      }
    } : transition,
    transitionEnd: {
      enter: transitionEnd == null ? void 0 : transitionEnd.enter,
      exit: unmountOnExit ? transitionEnd == null ? void 0 : transitionEnd.exit : _objectSpread(_objectSpread({}, transitionEnd == null ? void 0 : transitionEnd.exit), {}, {
        display: hasStartingHeight ? "block" : "none"
      })
    }
  };
  var show = unmountOnExit ? isOpen : true;
  var animate = isOpen || unmountOnExit ? "enter" : "exit";
  return /* @__PURE__ */React.createElement(AnimatePresence, {
    initial: false,
    custom: custom
  }, show && /* @__PURE__ */React.createElement(motion.div, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    className: cx("chakra-collapse", className),
    style: _objectSpread({
      overflow: "hidden",
      display: "block"
    }, style),
    custom: custom,
    variants: variants,
    initial: unmountOnExit ? "exit" : false,
    animate: animate,
    exit: "exit"
  })));
});
Collapse.displayName = "Collapse"; // src/fade.tsx

import { AnimatePresence as AnimatePresence2, motion as motion2 } from "framer-motion";
import { forwardRef as forwardRef2 } from "react";
var variants2 = {
  enter: function enter() {
    var _ref7;

    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        transition = _ref6.transition,
        transitionEnd = _ref6.transitionEnd,
        delay = _ref6.delay;

    return {
      opacity: 1,
      transition: (_ref7 = transition == null ? void 0 : transition.enter) !== null && _ref7 !== void 0 ? _ref7 : withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    };
  },
  exit: function exit() {
    var _ref9;

    var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        transition = _ref8.transition,
        transitionEnd = _ref8.transitionEnd,
        delay = _ref8.delay;

    return {
      opacity: 0,
      transition: (_ref9 = transition == null ? void 0 : transition.exit) !== null && _ref9 !== void 0 ? _ref9 : withDelay.exit(TRANSITION_DEFAULTS.exit, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    };
  }
};
var fadeConfig = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: variants2
};
var Fade = forwardRef2(function Fade2(props, ref) {
  var unmountOnExit = props.unmountOnExit,
      isOpen = props.in,
      className = props.className,
      transition = props.transition,
      transitionEnd = props.transitionEnd,
      delay = props.delay,
      rest = _objectWithoutProperties(props, _excluded2);

  var animate = isOpen || unmountOnExit ? "enter" : "exit";
  var show = unmountOnExit ? isOpen && unmountOnExit : true;
  var custom = {
    transition: transition,
    transitionEnd: transitionEnd,
    delay: delay
  };
  return /* @__PURE__ */React.createElement(AnimatePresence2, {
    custom: custom
  }, show && /* @__PURE__ */React.createElement(motion2.div, _objectSpread(_objectSpread({
    ref: ref,
    className: cx("chakra-fade", className),
    custom: custom
  }, fadeConfig), {}, {
    animate: animate
  }, rest)));
});
Fade.displayName = "Fade"; // src/scale-fade.tsx

import { AnimatePresence as AnimatePresence3, motion as motion3 } from "framer-motion";
import { forwardRef as forwardRef3 } from "react";
var variants3 = {
  exit: function exit(_ref10) {
    var _ref11;

    var reverse = _ref10.reverse,
        initialScale = _ref10.initialScale,
        transition = _ref10.transition,
        transitionEnd = _ref10.transitionEnd,
        delay = _ref10.delay;
    return _objectSpread(_objectSpread({
      opacity: 0
    }, reverse ? {
      scale: initialScale,
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    } : {
      transitionEnd: _objectSpread({
        scale: initialScale
      }, transitionEnd == null ? void 0 : transitionEnd.exit)
    }), {}, {
      transition: (_ref11 = transition == null ? void 0 : transition.exit) !== null && _ref11 !== void 0 ? _ref11 : withDelay.exit(TRANSITION_DEFAULTS.exit, delay)
    });
  },
  enter: function enter(_ref12) {
    var _ref13;

    var transitionEnd = _ref12.transitionEnd,
        transition = _ref12.transition,
        delay = _ref12.delay;
    return {
      opacity: 1,
      scale: 1,
      transition: (_ref13 = transition == null ? void 0 : transition.enter) !== null && _ref13 !== void 0 ? _ref13 : withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    };
  }
};
var scaleFadeConfig = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: variants3
};
var ScaleFade = forwardRef3(function ScaleFade2(props, ref) {
  var unmountOnExit = props.unmountOnExit,
      isOpen = props.in,
      _props$reverse = props.reverse,
      reverse = _props$reverse === void 0 ? true : _props$reverse,
      _props$initialScale = props.initialScale,
      initialScale = _props$initialScale === void 0 ? 0.95 : _props$initialScale,
      className = props.className,
      transition = props.transition,
      transitionEnd = props.transitionEnd,
      delay = props.delay,
      rest = _objectWithoutProperties(props, _excluded3);

  var show = unmountOnExit ? isOpen && unmountOnExit : true;
  var animate = isOpen || unmountOnExit ? "enter" : "exit";
  var custom = {
    initialScale: initialScale,
    reverse: reverse,
    transition: transition,
    transitionEnd: transitionEnd,
    delay: delay
  };
  return /* @__PURE__ */React.createElement(AnimatePresence3, {
    custom: custom
  }, show && /* @__PURE__ */React.createElement(motion3.div, _objectSpread(_objectSpread({
    ref: ref,
    className: cx("chakra-offset-slide", className)
  }, scaleFadeConfig), {}, {
    animate: animate,
    custom: custom
  }, rest)));
});
ScaleFade.displayName = "ScaleFade"; // src/slide.tsx

import { AnimatePresence as AnimatePresence4, motion as motion4 } from "framer-motion";
import { forwardRef as forwardRef4 } from "react";
var defaultTransition = {
  exit: {
    duration: 0.15,
    ease: TRANSITION_EASINGS.easeInOut
  },
  enter: {
    type: "spring",
    damping: 25,
    stiffness: 180
  }
};
var variants4 = {
  exit: function exit(_ref14) {
    var _ref15;

    var direction = _ref14.direction,
        transition = _ref14.transition,
        transitionEnd = _ref14.transitionEnd,
        delay = _ref14.delay;

    var _getSlideTransition = getSlideTransition({
      direction: direction
    }),
        exitStyles = _getSlideTransition.exit;

    return _objectSpread(_objectSpread({}, exitStyles), {}, {
      transition: (_ref15 = transition == null ? void 0 : transition.exit) !== null && _ref15 !== void 0 ? _ref15 : withDelay.exit(defaultTransition.exit, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    });
  },
  enter: function enter(_ref16) {
    var _ref17;

    var direction = _ref16.direction,
        transitionEnd = _ref16.transitionEnd,
        transition = _ref16.transition,
        delay = _ref16.delay;

    var _getSlideTransition2 = getSlideTransition({
      direction: direction
    }),
        enterStyles = _getSlideTransition2.enter;

    return _objectSpread(_objectSpread({}, enterStyles), {}, {
      transition: (_ref17 = transition == null ? void 0 : transition.enter) !== null && _ref17 !== void 0 ? _ref17 : withDelay.enter(defaultTransition.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    });
  }
};
var Slide = forwardRef4(function Slide2(props, ref) {
  var _props$direction = props.direction,
      direction = _props$direction === void 0 ? "right" : _props$direction,
      style = props.style,
      unmountOnExit = props.unmountOnExit,
      isOpen = props.in,
      className = props.className,
      transition = props.transition,
      transitionEnd = props.transitionEnd,
      delay = props.delay,
      motionProps = props.motionProps,
      rest = _objectWithoutProperties(props, _excluded4);

  var transitionStyles = getSlideTransition({
    direction: direction
  });
  var computedStyle = Object.assign({
    position: "fixed"
  }, transitionStyles.position, style);
  var show = unmountOnExit ? isOpen && unmountOnExit : true;
  var animate = isOpen || unmountOnExit ? "enter" : "exit";
  var custom = {
    transitionEnd: transitionEnd,
    transition: transition,
    direction: direction,
    delay: delay
  };
  return /* @__PURE__ */React.createElement(AnimatePresence4, {
    custom: custom
  }, show && /* @__PURE__ */React.createElement(motion4.div, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    initial: "exit",
    className: cx("chakra-slide", className),
    animate: animate,
    exit: "exit",
    custom: custom,
    variants: variants4,
    style: computedStyle
  }, motionProps)));
});
Slide.displayName = "Slide"; // src/slide-fade.tsx

import { AnimatePresence as AnimatePresence5, motion as motion5 } from "framer-motion";
import { forwardRef as forwardRef5 } from "react";
var variants5 = {
  initial: function initial(_ref18) {
    var _ref19;

    var offsetX = _ref18.offsetX,
        offsetY = _ref18.offsetY,
        transition = _ref18.transition,
        transitionEnd = _ref18.transitionEnd,
        delay = _ref18.delay;
    return {
      opacity: 0,
      x: offsetX,
      y: offsetY,
      transition: (_ref19 = transition == null ? void 0 : transition.exit) !== null && _ref19 !== void 0 ? _ref19 : withDelay.exit(TRANSITION_DEFAULTS.exit, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    };
  },
  enter: function enter(_ref20) {
    var _ref21;

    var transition = _ref20.transition,
        transitionEnd = _ref20.transitionEnd,
        delay = _ref20.delay;
    return {
      opacity: 1,
      x: 0,
      y: 0,
      transition: (_ref21 = transition == null ? void 0 : transition.enter) !== null && _ref21 !== void 0 ? _ref21 : withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    };
  },
  exit: function exit(_ref22) {
    var _ref23;

    var offsetY = _ref22.offsetY,
        offsetX = _ref22.offsetX,
        transition = _ref22.transition,
        transitionEnd = _ref22.transitionEnd,
        reverse = _ref22.reverse,
        delay = _ref22.delay;
    var offset = {
      x: offsetX,
      y: offsetY
    };
    return _objectSpread({
      opacity: 0,
      transition: (_ref23 = transition == null ? void 0 : transition.exit) !== null && _ref23 !== void 0 ? _ref23 : withDelay.exit(TRANSITION_DEFAULTS.exit, delay)
    }, reverse ? _objectSpread(_objectSpread({}, offset), {}, {
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    }) : {
      transitionEnd: _objectSpread(_objectSpread({}, offset), transitionEnd == null ? void 0 : transitionEnd.exit)
    });
  }
};
var slideFadeConfig = {
  initial: "initial",
  animate: "enter",
  exit: "exit",
  variants: variants5
};
var SlideFade = forwardRef5(function SlideFade2(props, ref) {
  var unmountOnExit = props.unmountOnExit,
      isOpen = props.in,
      _props$reverse2 = props.reverse,
      reverse = _props$reverse2 === void 0 ? true : _props$reverse2,
      className = props.className,
      _props$offsetX = props.offsetX,
      offsetX = _props$offsetX === void 0 ? 0 : _props$offsetX,
      _props$offsetY = props.offsetY,
      offsetY = _props$offsetY === void 0 ? 8 : _props$offsetY,
      transition = props.transition,
      transitionEnd = props.transitionEnd,
      delay = props.delay,
      rest = _objectWithoutProperties(props, _excluded5);

  var show = unmountOnExit ? isOpen && unmountOnExit : true;
  var animate = isOpen || unmountOnExit ? "enter" : "exit";
  var custom = {
    offsetX: offsetX,
    offsetY: offsetY,
    reverse: reverse,
    transition: transition,
    transitionEnd: transitionEnd,
    delay: delay
  };
  return /* @__PURE__ */React.createElement(AnimatePresence5, {
    custom: custom
  }, show && /* @__PURE__ */React.createElement(motion5.div, _objectSpread(_objectSpread({
    ref: ref,
    className: cx("chakra-offset-slide", className),
    custom: custom
  }, slideFadeConfig), {}, {
    animate: animate
  }, rest)));
});
SlideFade.displayName = "SlideFade";
export { Collapse, TRANSITION_EASINGS as EASINGS, Fade, ScaleFade, Slide, SlideFade, fadeConfig, getSlideTransition, scaleFadeConfig, slideFadeConfig, withDelay };